import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

const ColumnPrice = (props) => {
    if (!props.data) {
        return <span>—</span>;
    }
    const td = props.rowData.private_flag ? 'Private' :
        `${props.rowData.fee_cur_code} ${
            numeral(props.data * (props.rowData.exchange_rate || 1)).format('0,0')}`;
    return <span>{td}</span>;
};

ColumnPrice.propTypes = {
    rowData: PropTypes.object,
    data: PropTypes.number
};

export default ColumnPrice;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnPrice.js